import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, VERDE_WPP } from '../styles/colors';
import { buscarPerfil, listarPedidosCliente, logoutUsuario } from '../firebase';

function Home({ perfil, onNavegar }) {

  const [dadosCliente, setDadosCliente] = useState(null);
  const [vendedor,     setVendedor]     = useState(null);
  const [ultimoPedido, setUltimoPedido] = useState(null);

  useEffect(() => {
    carregarDados();
  }, []);

  async function carregarDados() {
    try {
      const perfilSalvo = JSON.parse(localStorage.getItem('perfil') || 'null');
      if (!perfilSalvo?.uid) return;

      const dados = await buscarPerfil(perfilSalvo.uid);
      setDadosCliente(dados);

      if (dados?.vendedorId) {
        const dadosVendedor = await buscarPerfil(dados.vendedorId);
        setVendedor(dadosVendedor);
      }

      const pedidos = await listarPedidosCliente(perfilSalvo.uid);
      if (pedidos.length > 0) {
        const ordenados = pedidos.sort((a, b) => {
          const ta = a.criadoEm?.seconds || 0;
          const tb = b.criadoEm?.seconds || 0;
          return tb - ta;
        });
        setUltimoPedido(ordenados[0]);
      }
    } catch (e) {
      console.error('Erro ao carregar dados:', e);
    }
  }

  async function handleSair() {
    if (!window.confirm('Deseja sair da sua conta?')) return;
    try {
      await logoutUsuario();
    } catch (e) {
      console.error('Erro ao sair:', e);
    }
    localStorage.removeItem('perfil');
    window.location.reload();
  }

  function saudacao() {
    const hora = new Date().getHours();
    if (hora < 12) return 'Bom dia,';
    if (hora < 18) return 'Boa tarde,';
    return 'Boa noite,';
  }

  function corStatus(status) {
    const cores = {
      pendente:   { bg: '#FFF3CD', cor: '#856404' },
      confirmado: { bg: '#D1ECF1', cor: '#0C5460' },
      enviado:    { bg: '#CCE5FF', cor: '#004085' },
      entregue:   { bg: '#D4EDDA', cor: '#155724' },
      cancelado:  { bg: '#F8D7DA', cor: '#721C24' },
    };
    return cores[status] || { bg: '#f4f4f2', cor: '#555' };
  }

  function labelStatus(status) {
    const labels = {
      pendente:   'Pendente',
      confirmado: 'Confirmado',
      enviado:    'Enviado',
      entregue:   'Entregue',
      cancelado:  'Cancelado',
    };
    return labels[status] || status;
  }

  const nomeCliente     = dadosCliente?.nome || 'Cliente';
  const iniciaisCliente = nomeCliente.split(' ').map(n => n[0]).slice(0, 2).join('');

  const navItems = [
    { id: 'home',      emoji: '🏠', label: 'Início'   },
    { id: 'catalogo',  emoji: '📦', label: 'Catálogo' },
    { id: 'carrinho',  emoji: '🛒', label: 'Carrinho' },
    { id: 'historico', emoji: '📋', label: 'Pedidos'  },
    { id: 'perfil',    emoji: '👤', label: 'Perfil'   },
  ];

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#f4f4f2' }}>

      {/* Header com navegação */}
      <div style={{ background: AZUL, padding: '14px 18px 0' }}>
        {/* Linha 1: saudação + sair */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11 }}>{saudacao()}</div>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 500 }}>{nomeCliente}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={handleSair}
              style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
              Sair
            </button>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: LARANJA, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#fff' }}>
              {iniciaisCliente}
            </div>
          </div>
        </div>
        {/* Linha 2: navegação */}
        <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => onNavegar(item.id)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 4px 10px', cursor: 'pointer', gap: 3, borderBottom: item.id === 'home' ? '2px solid #fff' : '2px solid transparent' }}>
              <span style={{ fontSize: 18 }}>{item.emoji}</span>
              <span style={{ fontSize: 9, color: item.id === 'home' ? '#fff' : 'rgba(255,255,255,0.6)', fontWeight: item.id === 'home' ? 600 : 400 }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 14px 0' }}>

        {/* Banner */}
        <div style={{ background: AZUL, borderRadius: 12, padding: 16, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>Catálogo completo</div>
            <div style={{ fontSize: 14, fontWeight: 500, color: '#fff', marginBottom: 8 }}>Explore todos os produtos</div>
            <div style={{ background: LARANJA, borderRadius: 6, padding: '6px 12px', fontSize: 11, fontWeight: 500, color: '#fff', display: 'inline-block', cursor: 'pointer' }}
              onClick={() => onNavegar('catalogo')}>
              Ver catálogo
            </div>
          </div>
          <div style={{ width: 60, height: 60, background: 'rgba(255,255,255,0.08)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28 }}>
            📦
          </div>
        </div>

        {/* Último pedido */}
        {ultimoPedido && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 500, color: '#1a1a1a' }}>Último pedido</span>
              <span style={{ fontSize: 11, color: AZUL, fontWeight: 500, cursor: 'pointer' }} onClick={() => onNavegar('historico')}>Ver todos</span>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 16, cursor: 'pointer' }}
              onClick={() => onNavegar('historico')}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: '#1a1a1a' }}>Pedido #{ultimoPedido.id?.slice(-6).toUpperCase()}</span>
                <span style={{
                  fontSize: 10, fontWeight: 600, borderRadius: 20, padding: '3px 10px',
                  background: corStatus(ultimoPedido.status).bg,
                  color: corStatus(ultimoPedido.status).cor,
                }}>
                  {labelStatus(ultimoPedido.status)}
                </span>
              </div>
              <div style={{ fontSize: 11, color: '#888' }}>
                {ultimoPedido.itens?.length || 0} {ultimoPedido.itens?.length === 1 ? 'item' : 'itens'}
                {ultimoPedido.total ? ` · R$ ${Number(ultimoPedido.total).toFixed(2).replace('.', ',')}` : ''}
              </div>
            </div>
          </>
        )}

        {/* Card vendedor */}
        {vendedor && (
          <>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#1a1a1a', marginBottom: 8 }}>Seu representante</div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 14px', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 500, color: '#27500A' }}>
                {vendedor.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Representante Apoio</div>
                <div style={{ fontSize: 12, fontWeight: 500, color: '#1a1a1a' }}>{vendedor.nome}</div>
              </div>
              <button
                onClick={() => window.open(`https://wa.me/55${vendedor.whatsapp?.replace(/\D/g, '')}`, '_blank')}
                style={{ background: VERDE_WPP, border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 10, color: '#fff', fontWeight: 500, cursor: 'pointer' }}>
                WhatsApp
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default Home;